import { gql } from 'apollo-boost';
import { useMutation } from '../';

const query = gql`
  mutation updateNpoReportAnswerValidation(
    $id: Int!,
    $answerId: Int!,
    $validationId: Int!,
    $hidden: Boolean,
  ) {
    updateNpoReportAnswerValidation(
      id: $id,
      answerId: $answerId,
      validationId: $validationId,
      hidden: $hidden,
    ) {
      id
      success
    }
  }
`;

export function useUpdateNpoReportAnswerValidation() {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    mutate(query, variables, (response) => {
      if (typeof onFinish === 'function') {
        onFinish(response.updateNpoReportAnswerValidation.id);
      }
    });
  };
  return { data, isLoading, run };
}
